/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ActionsIndexRouteImport } from './routes/actions/index'
import { Route as ActionsActionIdRouteImport } from './routes/actions/$actionId'
import { Route as AuctionIndexRouteImport } from './routes/auction/index'
import { Route as BonusesIndexRouteImport } from './routes/bonuses/index'
import { Route as ChartsIndexRouteImport } from './routes/charts/index'
import { Route as ClassicGuideIndexRouteImport } from './routes/classic-guide/index'
import { Route as ClassicGuidePageIdRouteImport } from './routes/classic-guide/$pageId'
import { Route as ClassicGuideAurasRouteImport } from './routes/classic-guide/auras'
import { Route as ClassicGuideDragonsRouteImport } from './routes/classic-guide/dragons'
import { Route as ClassicGuideExplorationRouteImport } from './routes/classic-guide/exploration'
import { Route as CombatIndexRouteImport } from './routes/combat/index'
import { Route as CommunicationIndexRouteImport } from './routes/communication/index'
import { Route as DiscordIndexRouteImport } from './routes/discord/index'
import { Route as DragonsIndexRouteImport } from './routes/dragons/index'
import { Route as EconomicsIndexRouteImport } from './routes/economics/index'
import { Route as ExplorationIndexRouteImport } from './routes/exploration/index'
import { Route as GemsIndexRouteImport } from './routes/gems/index'
import { Route as JubilantIndexRouteImport } from './routes/jubilant/index'
import { Route as KingdomIntelligenceIndexRouteImport } from './routes/kingdom-intelligence/index'
import { Route as KingdomRelationsIndexRouteImport } from './routes/kingdom-relations/index'
import { Route as MarketIndexRouteImport } from './routes/market/index'
import { Route as MilitaryIndexRouteImport } from './routes/military/index'
import { Route as MonarchyIndexRouteImport } from './routes/monarchy/index'
import { Route as MysticsIndexRouteImport } from './routes/mystics/index'
import { Route as NobilityIndexRouteImport } from './routes/nobility/index'
import { Route as PersonalitiesIndexRouteImport } from './routes/personalities/index'
import { Route as RacesIndexRouteImport } from './routes/races/index'
import { Route as ScienceIndexRouteImport } from './routes/science/index'
import { Route as ThieveryIndexRouteImport } from './routes/thievery/index'
import { Route as TradeIndexRouteImport } from './routes/trade/index'
import { Route as WikiIndexRouteImport } from './routes/wiki/index'
import { Route as WikiSectionIdRouteImport } from './routes/wiki/$sectionId'
import { Route as WikiDragonsRouteImport } from './routes/wiki/dragons'
import { Route as WikiPoliticsRouteImport } from './routes/wiki/politics'
import { Route as WikiProvinceManagementRouteImport } from './routes/wiki/province-management'
import { Route as ClassicGuideOperationsOperationKindOperationIdRouteImport } from './routes/classic-guide/operations/$operationKind/$operationId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ActionsIndexRoute = ActionsIndexRouteImport.update({
  id: '/actions/',
  path: '/actions/',
  getParentRoute: () => rootRouteImport,
} as any)
const ActionsActionIdRoute = ActionsActionIdRouteImport.update({
  id: '/actions/$actionId',
  path: '/actions/$actionId',
  getParentRoute: () => rootRouteImport,
} as any)
const AuctionIndexRoute = AuctionIndexRouteImport.update({
  id: '/auction/',
  path: '/auction/',
  getParentRoute: () => rootRouteImport,
} as any)
const BonusesIndexRoute = BonusesIndexRouteImport.update({
  id: '/bonuses/',
  path: '/bonuses/',
  getParentRoute: () => rootRouteImport,
} as any)
const ChartsIndexRoute = ChartsIndexRouteImport.update({
  id: '/charts/',
  path: '/charts/',
  getParentRoute: () => rootRouteImport,
} as any)
const ClassicGuideIndexRoute = ClassicGuideIndexRouteImport.update({
  id: '/classic-guide/',
  path: '/classic-guide/',
  getParentRoute: () => rootRouteImport,
} as any)
const ClassicGuidePageIdRoute = ClassicGuidePageIdRouteImport.update({
  id: '/classic-guide/$pageId',
  path: '/classic-guide/$pageId',
  getParentRoute: () => rootRouteImport,
} as any)
const ClassicGuideAurasRoute = ClassicGuideAurasRouteImport.update({
  id: '/classic-guide/auras',
  path: '/classic-guide/auras',
  getParentRoute: () => rootRouteImport,
} as any)
const ClassicGuideDragonsRoute = ClassicGuideDragonsRouteImport.update({
  id: '/classic-guide/dragons',
  path: '/classic-guide/dragons',
  getParentRoute: () => rootRouteImport,
} as any)
const ClassicGuideExplorationRoute = ClassicGuideExplorationRouteImport.update({
  id: '/classic-guide/exploration',
  path: '/classic-guide/exploration',
  getParentRoute: () => rootRouteImport,
} as any)
const CombatIndexRoute = CombatIndexRouteImport.update({
  id: '/combat/',
  path: '/combat/',
  getParentRoute: () => rootRouteImport,
} as any)
const CommunicationIndexRoute = CommunicationIndexRouteImport.update({
  id: '/communication/',
  path: '/communication/',
  getParentRoute: () => rootRouteImport,
} as any)
const DiscordIndexRoute = DiscordIndexRouteImport.update({
  id: '/discord/',
  path: '/discord/',
  getParentRoute: () => rootRouteImport,
} as any)
const DragonsIndexRoute = DragonsIndexRouteImport.update({
  id: '/dragons/',
  path: '/dragons/',
  getParentRoute: () => rootRouteImport,
} as any)
const EconomicsIndexRoute = EconomicsIndexRouteImport.update({
  id: '/economics/',
  path: '/economics/',
  getParentRoute: () => rootRouteImport,
} as any)
const ExplorationIndexRoute = ExplorationIndexRouteImport.update({
  id: '/exploration/',
  path: '/exploration/',
  getParentRoute: () => rootRouteImport,
} as any)
const GemsIndexRoute = GemsIndexRouteImport.update({
  id: '/gems/',
  path: '/gems/',
  getParentRoute: () => rootRouteImport,
} as any)
const JubilantIndexRoute = JubilantIndexRouteImport.update({
  id: '/jubilant/',
  path: '/jubilant/',
  getParentRoute: () => rootRouteImport,
} as any)
const KingdomIntelligenceIndexRoute =
  KingdomIntelligenceIndexRouteImport.update({
    id: '/kingdom-intelligence/',
    path: '/kingdom-intelligence/',
    getParentRoute: () => rootRouteImport,
  } as any)
const KingdomRelationsIndexRoute = KingdomRelationsIndexRouteImport.update({
  id: '/kingdom-relations/',
  path: '/kingdom-relations/',
  getParentRoute: () => rootRouteImport,
} as any)
const MarketIndexRoute = MarketIndexRouteImport.update({
  id: '/market/',
  path: '/market/',
  getParentRoute: () => rootRouteImport,
} as any)
const MilitaryIndexRoute = MilitaryIndexRouteImport.update({
  id: '/military/',
  path: '/military/',
  getParentRoute: () => rootRouteImport,
} as any)
const MonarchyIndexRoute = MonarchyIndexRouteImport.update({
  id: '/monarchy/',
  path: '/monarchy/',
  getParentRoute: () => rootRouteImport,
} as any)
const MysticsIndexRoute = MysticsIndexRouteImport.update({
  id: '/mystics/',
  path: '/mystics/',
  getParentRoute: () => rootRouteImport,
} as any)
const NobilityIndexRoute = NobilityIndexRouteImport.update({
  id: '/nobility/',
  path: '/nobility/',
  getParentRoute: () => rootRouteImport,
} as any)
const PersonalitiesIndexRoute = PersonalitiesIndexRouteImport.update({
  id: '/personalities/',
  path: '/personalities/',
  getParentRoute: () => rootRouteImport,
} as any)
const RacesIndexRoute = RacesIndexRouteImport.update({
  id: '/races/',
  path: '/races/',
  getParentRoute: () => rootRouteImport,
} as any)
const ScienceIndexRoute = ScienceIndexRouteImport.update({
  id: '/science/',
  path: '/science/',
  getParentRoute: () => rootRouteImport,
} as any)
const ThieveryIndexRoute = ThieveryIndexRouteImport.update({
  id: '/thievery/',
  path: '/thievery/',
  getParentRoute: () => rootRouteImport,
} as any)
const TradeIndexRoute = TradeIndexRouteImport.update({
  id: '/trade/',
  path: '/trade/',
  getParentRoute: () => rootRouteImport,
} as any)
const WikiIndexRoute = WikiIndexRouteImport.update({
  id: '/wiki/',
  path: '/wiki/',
  getParentRoute: () => rootRouteImport,
} as any)
const WikiSectionIdRoute = WikiSectionIdRouteImport.update({
  id: '/wiki/$sectionId',
  path: '/wiki/$sectionId',
  getParentRoute: () => rootRouteImport,
} as any)
const WikiDragonsRoute = WikiDragonsRouteImport.update({
  id: '/wiki/dragons',
  path: '/wiki/dragons',
  getParentRoute: () => rootRouteImport,
} as any)
const WikiPoliticsRoute = WikiPoliticsRouteImport.update({
  id: '/wiki/politics',
  path: '/wiki/politics',
  getParentRoute: () => rootRouteImport,
} as any)
const WikiProvinceManagementRoute = WikiProvinceManagementRouteImport.update({
  id: '/wiki/province-management',
  path: '/wiki/province-management',
  getParentRoute: () => rootRouteImport,
} as any)
const ClassicGuideOperationsOperationKindOperationIdRoute =
  ClassicGuideOperationsOperationKindOperationIdRouteImport.update({
    id: '/classic-guide/operations/$operationKind/$operationId',
    path: '/classic-guide/operations/$operationKind/$operationId',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/actions/$actionId': typeof ActionsActionIdRoute
  '/classic-guide/$pageId': typeof ClassicGuidePageIdRoute
  '/classic-guide/auras': typeof ClassicGuideAurasRoute
  '/classic-guide/dragons': typeof ClassicGuideDragonsRoute
  '/classic-guide/exploration': typeof ClassicGuideExplorationRoute
  '/wiki/$sectionId': typeof WikiSectionIdRoute
  '/wiki/dragons': typeof WikiDragonsRoute
  '/wiki/politics': typeof WikiPoliticsRoute
  '/wiki/province-management': typeof WikiProvinceManagementRoute
  '/actions/': typeof ActionsIndexRoute
  '/auction/': typeof AuctionIndexRoute
  '/bonuses/': typeof BonusesIndexRoute
  '/charts/': typeof ChartsIndexRoute
  '/classic-guide/': typeof ClassicGuideIndexRoute
  '/combat/': typeof CombatIndexRoute
  '/communication/': typeof CommunicationIndexRoute
  '/discord/': typeof DiscordIndexRoute
  '/dragons/': typeof DragonsIndexRoute
  '/economics/': typeof EconomicsIndexRoute
  '/exploration/': typeof ExplorationIndexRoute
  '/gems/': typeof GemsIndexRoute
  '/jubilant/': typeof JubilantIndexRoute
  '/kingdom-intelligence/': typeof KingdomIntelligenceIndexRoute
  '/kingdom-relations/': typeof KingdomRelationsIndexRoute
  '/market/': typeof MarketIndexRoute
  '/military/': typeof MilitaryIndexRoute
  '/monarchy/': typeof MonarchyIndexRoute
  '/mystics/': typeof MysticsIndexRoute
  '/nobility/': typeof NobilityIndexRoute
  '/personalities/': typeof PersonalitiesIndexRoute
  '/races/': typeof RacesIndexRoute
  '/science/': typeof ScienceIndexRoute
  '/thievery/': typeof ThieveryIndexRoute
  '/trade/': typeof TradeIndexRoute
  '/wiki/': typeof WikiIndexRoute
  '/classic-guide/operations/$operationKind/$operationId': typeof ClassicGuideOperationsOperationKindOperationIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/actions/$actionId': typeof ActionsActionIdRoute
  '/classic-guide/$pageId': typeof ClassicGuidePageIdRoute
  '/classic-guide/auras': typeof ClassicGuideAurasRoute
  '/classic-guide/dragons': typeof ClassicGuideDragonsRoute
  '/classic-guide/exploration': typeof ClassicGuideExplorationRoute
  '/wiki/$sectionId': typeof WikiSectionIdRoute
  '/wiki/dragons': typeof WikiDragonsRoute
  '/wiki/politics': typeof WikiPoliticsRoute
  '/wiki/province-management': typeof WikiProvinceManagementRoute
  '/actions': typeof ActionsIndexRoute
  '/auction': typeof AuctionIndexRoute
  '/bonuses': typeof BonusesIndexRoute
  '/charts': typeof ChartsIndexRoute
  '/classic-guide': typeof ClassicGuideIndexRoute
  '/combat': typeof CombatIndexRoute
  '/communication': typeof CommunicationIndexRoute
  '/discord': typeof DiscordIndexRoute
  '/dragons': typeof DragonsIndexRoute
  '/economics': typeof EconomicsIndexRoute
  '/exploration': typeof ExplorationIndexRoute
  '/gems': typeof GemsIndexRoute
  '/jubilant': typeof JubilantIndexRoute
  '/kingdom-intelligence': typeof KingdomIntelligenceIndexRoute
  '/kingdom-relations': typeof KingdomRelationsIndexRoute
  '/market': typeof MarketIndexRoute
  '/military': typeof MilitaryIndexRoute
  '/monarchy': typeof MonarchyIndexRoute
  '/mystics': typeof MysticsIndexRoute
  '/nobility': typeof NobilityIndexRoute
  '/personalities': typeof PersonalitiesIndexRoute
  '/races': typeof RacesIndexRoute
  '/science': typeof ScienceIndexRoute
  '/thievery': typeof ThieveryIndexRoute
  '/trade': typeof TradeIndexRoute
  '/wiki': typeof WikiIndexRoute
  '/classic-guide/operations/$operationKind/$operationId': typeof ClassicGuideOperationsOperationKindOperationIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/actions/$actionId': typeof ActionsActionIdRoute
  '/classic-guide/$pageId': typeof ClassicGuidePageIdRoute
  '/classic-guide/auras': typeof ClassicGuideAurasRoute
  '/classic-guide/dragons': typeof ClassicGuideDragonsRoute
  '/classic-guide/exploration': typeof ClassicGuideExplorationRoute
  '/wiki/$sectionId': typeof WikiSectionIdRoute
  '/wiki/dragons': typeof WikiDragonsRoute
  '/wiki/politics': typeof WikiPoliticsRoute
  '/wiki/province-management': typeof WikiProvinceManagementRoute
  '/actions/': typeof ActionsIndexRoute
  '/auction/': typeof AuctionIndexRoute
  '/bonuses/': typeof BonusesIndexRoute
  '/charts/': typeof ChartsIndexRoute
  '/classic-guide/': typeof ClassicGuideIndexRoute
  '/combat/': typeof CombatIndexRoute
  '/communication/': typeof CommunicationIndexRoute
  '/discord/': typeof DiscordIndexRoute
  '/dragons/': typeof DragonsIndexRoute
  '/economics/': typeof EconomicsIndexRoute
  '/exploration/': typeof ExplorationIndexRoute
  '/gems/': typeof GemsIndexRoute
  '/jubilant/': typeof JubilantIndexRoute
  '/kingdom-intelligence/': typeof KingdomIntelligenceIndexRoute
  '/kingdom-relations/': typeof KingdomRelationsIndexRoute
  '/market/': typeof MarketIndexRoute
  '/military/': typeof MilitaryIndexRoute
  '/monarchy/': typeof MonarchyIndexRoute
  '/mystics/': typeof MysticsIndexRoute
  '/nobility/': typeof NobilityIndexRoute
  '/personalities/': typeof PersonalitiesIndexRoute
  '/races/': typeof RacesIndexRoute
  '/science/': typeof ScienceIndexRoute
  '/thievery/': typeof ThieveryIndexRoute
  '/trade/': typeof TradeIndexRoute
  '/wiki/': typeof WikiIndexRoute
  '/classic-guide/operations/$operationKind/$operationId': typeof ClassicGuideOperationsOperationKindOperationIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/actions/$actionId'
    | '/classic-guide/$pageId'
    | '/classic-guide/auras'
    | '/classic-guide/dragons'
    | '/classic-guide/exploration'
    | '/wiki/$sectionId'
    | '/wiki/dragons'
    | '/wiki/politics'
    | '/wiki/province-management'
    | '/actions/'
    | '/auction/'
    | '/bonuses/'
    | '/charts/'
    | '/classic-guide/'
    | '/combat/'
    | '/communication/'
    | '/discord/'
    | '/dragons/'
    | '/economics/'
    | '/exploration/'
    | '/gems/'
    | '/jubilant/'
    | '/kingdom-intelligence/'
    | '/kingdom-relations/'
    | '/market/'
    | '/military/'
    | '/monarchy/'
    | '/mystics/'
    | '/nobility/'
    | '/personalities/'
    | '/races/'
    | '/science/'
    | '/thievery/'
    | '/trade/'
    | '/wiki/'
    | '/classic-guide/operations/$operationKind/$operationId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/actions/$actionId'
    | '/classic-guide/$pageId'
    | '/classic-guide/auras'
    | '/classic-guide/dragons'
    | '/classic-guide/exploration'
    | '/wiki/$sectionId'
    | '/wiki/dragons'
    | '/wiki/politics'
    | '/wiki/province-management'
    | '/actions'
    | '/auction'
    | '/bonuses'
    | '/charts'
    | '/classic-guide'
    | '/combat'
    | '/communication'
    | '/discord'
    | '/dragons'
    | '/economics'
    | '/exploration'
    | '/gems'
    | '/jubilant'
    | '/kingdom-intelligence'
    | '/kingdom-relations'
    | '/market'
    | '/military'
    | '/monarchy'
    | '/mystics'
    | '/nobility'
    | '/personalities'
    | '/races'
    | '/science'
    | '/thievery'
    | '/trade'
    | '/wiki'
    | '/classic-guide/operations/$operationKind/$operationId'
  id:
    | '__root__'
    | '/'
    | '/actions/$actionId'
    | '/classic-guide/$pageId'
    | '/classic-guide/auras'
    | '/classic-guide/dragons'
    | '/classic-guide/exploration'
    | '/wiki/$sectionId'
    | '/wiki/dragons'
    | '/wiki/politics'
    | '/wiki/province-management'
    | '/actions/'
    | '/auction/'
    | '/bonuses/'
    | '/charts/'
    | '/classic-guide/'
    | '/combat/'
    | '/communication/'
    | '/discord/'
    | '/dragons/'
    | '/economics/'
    | '/exploration/'
    | '/gems/'
    | '/jubilant/'
    | '/kingdom-intelligence/'
    | '/kingdom-relations/'
    | '/market/'
    | '/military/'
    | '/monarchy/'
    | '/mystics/'
    | '/nobility/'
    | '/personalities/'
    | '/races/'
    | '/science/'
    | '/thievery/'
    | '/trade/'
    | '/wiki/'
    | '/classic-guide/operations/$operationKind/$operationId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ActionsActionIdRoute: typeof ActionsActionIdRoute
  ClassicGuidePageIdRoute: typeof ClassicGuidePageIdRoute
  ClassicGuideAurasRoute: typeof ClassicGuideAurasRoute
  ClassicGuideDragonsRoute: typeof ClassicGuideDragonsRoute
  ClassicGuideExplorationRoute: typeof ClassicGuideExplorationRoute
  WikiSectionIdRoute: typeof WikiSectionIdRoute
  WikiDragonsRoute: typeof WikiDragonsRoute
  WikiPoliticsRoute: typeof WikiPoliticsRoute
  WikiProvinceManagementRoute: typeof WikiProvinceManagementRoute
  ActionsIndexRoute: typeof ActionsIndexRoute
  AuctionIndexRoute: typeof AuctionIndexRoute
  BonusesIndexRoute: typeof BonusesIndexRoute
  ChartsIndexRoute: typeof ChartsIndexRoute
  ClassicGuideIndexRoute: typeof ClassicGuideIndexRoute
  CombatIndexRoute: typeof CombatIndexRoute
  CommunicationIndexRoute: typeof CommunicationIndexRoute
  DiscordIndexRoute: typeof DiscordIndexRoute
  DragonsIndexRoute: typeof DragonsIndexRoute
  EconomicsIndexRoute: typeof EconomicsIndexRoute
  ExplorationIndexRoute: typeof ExplorationIndexRoute
  GemsIndexRoute: typeof GemsIndexRoute
  JubilantIndexRoute: typeof JubilantIndexRoute
  KingdomIntelligenceIndexRoute: typeof KingdomIntelligenceIndexRoute
  KingdomRelationsIndexRoute: typeof KingdomRelationsIndexRoute
  MarketIndexRoute: typeof MarketIndexRoute
  MilitaryIndexRoute: typeof MilitaryIndexRoute
  MonarchyIndexRoute: typeof MonarchyIndexRoute
  MysticsIndexRoute: typeof MysticsIndexRoute
  NobilityIndexRoute: typeof NobilityIndexRoute
  PersonalitiesIndexRoute: typeof PersonalitiesIndexRoute
  RacesIndexRoute: typeof RacesIndexRoute
  ScienceIndexRoute: typeof ScienceIndexRoute
  ThieveryIndexRoute: typeof ThieveryIndexRoute
  TradeIndexRoute: typeof TradeIndexRoute
  WikiIndexRoute: typeof WikiIndexRoute
  ClassicGuideOperationsOperationKindOperationIdRoute: typeof ClassicGuideOperationsOperationKindOperationIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/actions/': {
      id: '/actions/'
      path: '/actions'
      fullPath: '/actions/'
      preLoaderRoute: typeof ActionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/actions/$actionId': {
      id: '/actions/$actionId'
      path: '/actions/$actionId'
      fullPath: '/actions/$actionId'
      preLoaderRoute: typeof ActionsActionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auction/': {
      id: '/auction/'
      path: '/auction'
      fullPath: '/auction/'
      preLoaderRoute: typeof AuctionIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bonuses/': {
      id: '/bonuses/'
      path: '/bonuses'
      fullPath: '/bonuses/'
      preLoaderRoute: typeof BonusesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/charts/': {
      id: '/charts/'
      path: '/charts'
      fullPath: '/charts/'
      preLoaderRoute: typeof ChartsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/classic-guide/': {
      id: '/classic-guide/'
      path: '/classic-guide'
      fullPath: '/classic-guide/'
      preLoaderRoute: typeof ClassicGuideIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/classic-guide/$pageId': {
      id: '/classic-guide/$pageId'
      path: '/classic-guide/$pageId'
      fullPath: '/classic-guide/$pageId'
      preLoaderRoute: typeof ClassicGuidePageIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/classic-guide/auras': {
      id: '/classic-guide/auras'
      path: '/classic-guide/auras'
      fullPath: '/classic-guide/auras'
      preLoaderRoute: typeof ClassicGuideAurasRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/classic-guide/dragons': {
      id: '/classic-guide/dragons'
      path: '/classic-guide/dragons'
      fullPath: '/classic-guide/dragons'
      preLoaderRoute: typeof ClassicGuideDragonsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/classic-guide/exploration': {
      id: '/classic-guide/exploration'
      path: '/classic-guide/exploration'
      fullPath: '/classic-guide/exploration'
      preLoaderRoute: typeof ClassicGuideExplorationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/combat/': {
      id: '/combat/'
      path: '/combat'
      fullPath: '/combat/'
      preLoaderRoute: typeof CombatIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/communication/': {
      id: '/communication/'
      path: '/communication'
      fullPath: '/communication/'
      preLoaderRoute: typeof CommunicationIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/discord/': {
      id: '/discord/'
      path: '/discord'
      fullPath: '/discord/'
      preLoaderRoute: typeof DiscordIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dragons/': {
      id: '/dragons/'
      path: '/dragons'
      fullPath: '/dragons/'
      preLoaderRoute: typeof DragonsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/economics/': {
      id: '/economics/'
      path: '/economics'
      fullPath: '/economics/'
      preLoaderRoute: typeof EconomicsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/exploration/': {
      id: '/exploration/'
      path: '/exploration'
      fullPath: '/exploration/'
      preLoaderRoute: typeof ExplorationIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gems/': {
      id: '/gems/'
      path: '/gems'
      fullPath: '/gems/'
      preLoaderRoute: typeof GemsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/jubilant/': {
      id: '/jubilant/'
      path: '/jubilant'
      fullPath: '/jubilant/'
      preLoaderRoute: typeof JubilantIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kingdom-intelligence/': {
      id: '/kingdom-intelligence/'
      path: '/kingdom-intelligence'
      fullPath: '/kingdom-intelligence/'
      preLoaderRoute: typeof KingdomIntelligenceIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kingdom-relations/': {
      id: '/kingdom-relations/'
      path: '/kingdom-relations'
      fullPath: '/kingdom-relations/'
      preLoaderRoute: typeof KingdomRelationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/market/': {
      id: '/market/'
      path: '/market'
      fullPath: '/market/'
      preLoaderRoute: typeof MarketIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/military/': {
      id: '/military/'
      path: '/military'
      fullPath: '/military/'
      preLoaderRoute: typeof MilitaryIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/monarchy/': {
      id: '/monarchy/'
      path: '/monarchy'
      fullPath: '/monarchy/'
      preLoaderRoute: typeof MonarchyIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mystics/': {
      id: '/mystics/'
      path: '/mystics'
      fullPath: '/mystics/'
      preLoaderRoute: typeof MysticsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/nobility/': {
      id: '/nobility/'
      path: '/nobility'
      fullPath: '/nobility/'
      preLoaderRoute: typeof NobilityIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/personalities/': {
      id: '/personalities/'
      path: '/personalities'
      fullPath: '/personalities/'
      preLoaderRoute: typeof PersonalitiesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/races/': {
      id: '/races/'
      path: '/races'
      fullPath: '/races/'
      preLoaderRoute: typeof RacesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/science/': {
      id: '/science/'
      path: '/science'
      fullPath: '/science/'
      preLoaderRoute: typeof ScienceIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/thievery/': {
      id: '/thievery/'
      path: '/thievery'
      fullPath: '/thievery/'
      preLoaderRoute: typeof ThieveryIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trade/': {
      id: '/trade/'
      path: '/trade'
      fullPath: '/trade/'
      preLoaderRoute: typeof TradeIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/wiki/': {
      id: '/wiki/'
      path: '/wiki'
      fullPath: '/wiki/'
      preLoaderRoute: typeof WikiIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/wiki/$sectionId': {
      id: '/wiki/$sectionId'
      path: '/wiki/$sectionId'
      fullPath: '/wiki/$sectionId'
      preLoaderRoute: typeof WikiSectionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/wiki/dragons': {
      id: '/wiki/dragons'
      path: '/wiki/dragons'
      fullPath: '/wiki/dragons'
      preLoaderRoute: typeof WikiDragonsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/wiki/politics': {
      id: '/wiki/politics'
      path: '/wiki/politics'
      fullPath: '/wiki/politics'
      preLoaderRoute: typeof WikiPoliticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/wiki/province-management': {
      id: '/wiki/province-management'
      path: '/wiki/province-management'
      fullPath: '/wiki/province-management'
      preLoaderRoute: typeof WikiProvinceManagementRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/classic-guide/operations/$operationKind/$operationId': {
      id: '/classic-guide/operations/$operationKind/$operationId'
      path: '/classic-guide/operations/$operationKind/$operationId'
      fullPath: '/classic-guide/operations/$operationKind/$operationId'
      preLoaderRoute: typeof ClassicGuideOperationsOperationKindOperationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ActionsActionIdRoute: ActionsActionIdRoute,
  ClassicGuidePageIdRoute: ClassicGuidePageIdRoute,
  ClassicGuideAurasRoute: ClassicGuideAurasRoute,
  ClassicGuideDragonsRoute: ClassicGuideDragonsRoute,
  ClassicGuideExplorationRoute: ClassicGuideExplorationRoute,
  WikiSectionIdRoute: WikiSectionIdRoute,
  WikiDragonsRoute: WikiDragonsRoute,
  WikiPoliticsRoute: WikiPoliticsRoute,
  WikiProvinceManagementRoute: WikiProvinceManagementRoute,
  ActionsIndexRoute: ActionsIndexRoute,
  AuctionIndexRoute: AuctionIndexRoute,
  BonusesIndexRoute: BonusesIndexRoute,
  ChartsIndexRoute: ChartsIndexRoute,
  ClassicGuideIndexRoute: ClassicGuideIndexRoute,
  CombatIndexRoute: CombatIndexRoute,
  CommunicationIndexRoute: CommunicationIndexRoute,
  DiscordIndexRoute: DiscordIndexRoute,
  DragonsIndexRoute: DragonsIndexRoute,
  EconomicsIndexRoute: EconomicsIndexRoute,
  ExplorationIndexRoute: ExplorationIndexRoute,
  GemsIndexRoute: GemsIndexRoute,
  JubilantIndexRoute: JubilantIndexRoute,
  KingdomIntelligenceIndexRoute: KingdomIntelligenceIndexRoute,
  KingdomRelationsIndexRoute: KingdomRelationsIndexRoute,
  MarketIndexRoute: MarketIndexRoute,
  MilitaryIndexRoute: MilitaryIndexRoute,
  MonarchyIndexRoute: MonarchyIndexRoute,
  MysticsIndexRoute: MysticsIndexRoute,
  NobilityIndexRoute: NobilityIndexRoute,
  PersonalitiesIndexRoute: PersonalitiesIndexRoute,
  RacesIndexRoute: RacesIndexRoute,
  ScienceIndexRoute: ScienceIndexRoute,
  ThieveryIndexRoute: ThieveryIndexRoute,
  TradeIndexRoute: TradeIndexRoute,
  WikiIndexRoute: WikiIndexRoute,
  ClassicGuideOperationsOperationKindOperationIdRoute:
    ClassicGuideOperationsOperationKindOperationIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
